import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const BackIcon: React.FC<Props> = (props) => {
  return (
    <svg
      {...props}
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="back icon">
      {/* <title>back icon</title> */}
      <path
        d="M0.369879 7.99983C0.369879 7.44771 0.818243 6.99934 1.37037 6.99934L15.5043 6.99934L9.9747 1.72398C9.57364 1.34246 9.5593 0.70683 9.94085 0.309719C10.3224 -0.0900574 10.9551 -0.104393 11.3551 0.275863L18.6889 7.27634C18.888 7.46229 19 7.72481 19 7.99983C19 8.27485 18.888 8.5332 18.6901 8.72488L11.3563 15.7254C10.9581 16.1041 10.3247 16.09 9.94137 15.6899C9.55984 15.2941 9.57418 14.6586 9.97523 14.2757L15.5048 9.00032L1.33297 9.00032C0.782408 8.9999 0.369879 8.54987 0.369879 7.99983Z"
        fill={props.fill || "#52525B"}
      />
    </svg>
  );
};

export default BackIcon;
